import { OutOfBoundsStrategy } from "../drag-and-drop.interface";

export class NoopStrategy implements OutOfBoundsStrategy {
    handleOutOfBounds(): void {}
    handleReturnInBounds(): void {}
    handleDragEnd(): void {}
}
